import React, { useState } from "react";
import { Link } from "react-router-dom";
import essays from "../data/essays";
import Modal from "../components/Modal";

function Essays() {
  const [active, setActive] = useState(null);

  return (
    <main className="page-main fade-up">
      <Link to="/" className="back-link">
        ← Index
      </Link>
      <div className="eyebrow">(02) — Writing</div>
      <h1 className="page-title">essays</h1>
      <p className="page-intro">
        Notes on building software & and the things
        that actually matter.
      </p>

      <div className="list">
        {essays.map((item) => (
          <button
            key={item.title}
            className="essay-row"
            onClick={() => setActive(item)}
          >
            <span className="essay-date">{item.date}</span>
            <div>
              <h3 className="essay-title">{item.title}</h3>
              <p className="essay-dek">{item.dek}</p>
            </div>
            <span className="essay-tag">{item.tag} →</span>
          </button>
        ))}
      </div>

      {active && (
        <Modal onClose={() => setActive(null)}>
          <div className="modal-eyebrow">
            {active.tag} · {active.date}
          </div>
          <h2 className="modal-title">{active.title}</h2>
          <p className="modal-sub">{active.dek}</p>
          {active.body ? (
            <div className="modal-body">{active.body}</div>
          ) : (
            <p className="modal-placeholder">This essay is coming soon.</p>
          )}
        </Modal>
      )}
    </main>
  );
}

export default Essays;
